<template>
    <div class="apply">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
        />
        <div class="apply_container">
            <OpenPrice :price='totalAmount' />
            <div class="apply_container_one">
                <CheckList v-for="(item, index) in inputList" :item='item' :key='index' />
            </div>
            <div class="apply_container_two" v-if="address">
                <div class="apply_container_two_address">
                    <div class="acoa_img">
                        <img src="../../../assets/img/b2b/home_image_3@2x.png" alt="">
                    </div>
                    <div class="acoa_content">
                        <h3>{{ address.name + ' ' + address.phone }}</h3>
                        <p>{{ address.province + address.city + address.area + address.address }}</p>
                    </div>
                </div>
                <div class="apply_container_two_list">
                    <CheckList v-for="(item, index) in checkList" :item='item' :key='index' />
                </div>
            </div>
            <div class="apply_container_three">
                <StayInvoice v-for="(item, index) in productList" :key="index" :invoice='item' :status='status' :mold='false' />
            </div>
        </div>
    </div>
</template>

<script>
import Head from '../../common/head'
import OpenPrice from './common/openPrice'
import CheckList from './common/checkList'
import StayInvoice from './publicTemplate/stayInvoice'
import { invoiceDetailData } from '../api/order'
export default {
    name: 'invoiceDetail',
    components: {
        Head,
        OpenPrice,
        CheckList,
        StayInvoice
    },
    data () {
        return {
            headInfo: {
                title: '申请开票'
            },
            status: 10,
            address: null,
            totalAmount: 0,
            productList: [],
            inputList: [],
            checkList: []
        }
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/invoice/invoiceList', query: { active: this.$route.query.active } })
        },
        async initDetail () {
            const { data } = await invoiceDetailData({
                id: this.$route.query.id
            })
            if (data.titleType === 2) {
                this.inputList = [
                    { label: '抬头类型', content: '企业' },
                    { label: '发票抬头', content: data.title },
                    { label: '税号', content: data.taxNo },
                    { label: '开户银行', content: data.openingBank },
                    { label: '银行账号', content: data.bankAccount },
                    { label: '企业地址', content: data.companyAddress },
                    { label: '企业电话', content: data.companyPhone },
                    { label: '邮箱', content: data.email }
                ]
            } else {
                this.inputList = [
                    { label: '抬头类型', content: '个人' },
                    { label: '发票抬头', content: data.title },
                    { label: '邮箱', content: data.email }
                ]
            }
            this.address = data.address
            this.checkList = [
                { label: '发票类型', content: data.invoiceType === 1 ? '增值税专用发票（纸质）' : '增值税普通发票（纸质）', colTrue: true }
            ]
            if (data.status === 30) {
                this.checkList = [
                    ...this.checkList,
                    { label: '发票代码', content: data.invoiceCode },
                    { label: '发票号码', content: data.invoiceNumber },
                    { label: '快递单号', content: data.deliveryCompanyName + ' ' + data.deliveryNo }
                ]
            }
            this.productList = data.deliveryInfoList
            this.status = data.status
            this.totalAmount = data.totalAmount
        }
    },
    mounted () {
        this.initDetail()
    }
}
</script>

<style lang="scss" scoped>
.apply {
    &_container {
        padding-bottom: 60px;
        &_one {
            margin: 20px 16px 0;
            background-color: #fff;
            padding: 32px 24px;
        }
        &_two {
            margin: 20px 16px 0;
            background-color: #fff;
            padding: 32px 0 32px 24px;
            &_address{
                display: flex;
                justify-content: start;
                border-bottom: 2px solid #EDEDF0;
                padding: 4px 0 36px;
                margin-bottom: 32px;
                .acoa_img {
                    width: 80px;
                    border-radius: 50%;
                    margin-right: 32px;
                    img {
                        border-radius: 50%;
                    }
                }
                .acoa_content {
                    flex: 1;
                    align-self: center;
                    h3 {
                        font-size: 32px;
                        color: #000;
                    }
                    p {
                        font-size: 24px;
                        color: #666;
                        margin-top: 4px;
                    }
                }
            }
        }
        &_three {
            margin: 20px 16px 0;
            // background-color: #fff;
        }
    }
}
</style>